
// import { useState } from "react";
// import ComparisonTable from "./ComparisonTable";
// import HotelSearchBox from "./HotelSearchBox";
// import styles from "./HotelComparison.module.css";

// const MAX_COMPARE = 4;

// const COMPARISON_FIELDS = [
//   { key: "location", label: "Location" },
//   { key: "category", label: "Category" },
//   { key: "rooms", label: "Rooms" },
//   { key: "ballrooms", label: "Ballrooms" },
//   { key: "max_capacity", label: "Maximum Capacity" },
//   { key: "amenities", label: "Amenities" },
//   { key: "facilities", label: "Facilities" },
//   { key: "description", label: "Description" },
// ];

// function HotelComparison({
//   hotels = [],
//   selectedHotels = [],
//   setSelectedHotels,
// }) {
//   const [searchSlots, setSearchSlots] = useState(1);

//   const addHotel = (hotel) => {
//     if (!hotel?.id || selectedHotels.some((h) => h.id === hotel.id)) {
//       return;
//     }

//     if (selectedHotels.length >= MAX_COMPARE) return;

//     setSelectedHotels((prev) => [...prev, hotel]);

//     if (selectedHotels.length + 1 < MAX_COMPARE) {
//       setSearchSlots((prev) => prev + 1);
//     }
//   };

//   const removeHotel = (hotelId) => {
//     setSelectedHotels((prev) =>
//       prev.filter((hotel) => hotel.id !== hotelId)
//     );
//   };

//   const clearComparison = () => {
//     setSelectedHotels([]);
//     setSearchSlots(1);
//   };

//   return (
//     <section className={styles.comparisonWrapper}>
//       <div className={styles.comparisonHeader}>
//         <div>
//           <h2>Compare Hotels</h2>
//           <p>Compare up to {MAX_COMPARE} hotels side by side.</p>
//         </div>

//         {selectedHotels.length > 0 && (
//           <button
//             type="button"
//             className={styles.clearButton}
//             onClick={clearComparison}
//           >
//             Clear All
//           </button>
//         )}
//       </div>

//       <div className={styles.hotelSearchArea}>
//         <div className={styles.searchGrid}>
//           {Array.from({ length: searchSlots }).map((_, index) => {
//             const hotel = selectedHotels[index];

//             return (
//               <HotelSearchBox
//                 key={hotel?.id || `search-${index}`}
//                 hotels={hotels}
//                 selectedHotels={selectedHotels}
//                 selectedHotel={hotel}
//                 onSelect={addHotel}
//                 onRemove={removeHotel}
//               />
//             );
//           })}
//         </div>
//       </div>

//       {selectedHotels.length < 2 ? (
//         <div className={styles.emptyState}>
//           <h3>Select Hotels to Compare</h3>
//           <p>
//             Search and select at least 2 hotels to compare
//             their facilities, capacities, amenities and
//             other details.
//           </p>
//         </div>
//       ) : (
//         <ComparisonTable
//           hotels={selectedHotels}
//           fields={COMPARISON_FIELDS}
//           onRemove={removeHotel}
//         />
//       )}
//     </section>
//   );
// }

// export default HotelComparison;

import ComparisonTable from "./ComparisonTable";
import HotelSearchBox from "./HotelSearchBox";
import styles from "./HotelComparison.module.css";

const MAX_COMPARE = 4;

const COMPARISON_FIELDS = [
  { key: "location", label: "Location" },
  { key: "category", label: "Category" },
  { key: "rooms", label: "Rooms" },
  { key: "ballrooms", label: "Ballrooms" },
  { key: "max_capacity", label: "Maximum Capacity" },
  { key: "amenities", label: "Amenities" },
  { key: "facilities", label: "Facilities" },
  { key: "description", label: "Description" },
];

function HotelComparison({
  hotels = [],
  selectedHotels = [],
  setSelectedHotels,
}) {
  const addHotel = (hotel) => {
    if (!hotel?.id || selectedHotels.some((h) => h.id === hotel.id)) {
      return;
    }

    if (selectedHotels.length >= MAX_COMPARE) return;

    setSelectedHotels((prev) => [...prev, hotel]);
  };

  const removeHotel = (hotelId) => {
    setSelectedHotels((prev) =>
      prev.filter((hotel) => hotel.id !== hotelId)
    );
  };

  const clearComparison = () => {
    setSelectedHotels([]);
  };

  // Selected hotels + 1 empty search box
  const searchSlots = Math.min(
    selectedHotels.length + 1,
    MAX_COMPARE
  );

  return (
    <section className={styles.comparisonWrapper}>
      <div className={styles.comparisonHeader}>
        <div>
          <h2>Compare Venues</h2>
          <p>Compare up to {MAX_COMPARE} Venues side by side.</p>
        </div>

        {selectedHotels.length > 0 && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={clearComparison}
          >
            Clear All
          </button>
        )}
      </div>

      <div className={styles.hotelSearchArea}>
        <div className={styles.searchGrid}>
          {Array.from({ length: searchSlots }).map((_, index) => {
            const hotel = selectedHotels[index];

            return (
              <HotelSearchBox
                key={hotel?.id || `search-${index}`}
                hotels={hotels}
                selectedHotels={selectedHotels}
                selectedHotel={hotel}
                onSelect={addHotel}
                onRemove={removeHotel}
              />
            );
          })}
        </div>
      </div>

      {selectedHotels.length < 2 ? (
        <div className={styles.emptyState}>
          <h3>Select Hotels to Compare</h3>
          <p>
            Search and select at least 2 hotels to compare
            their facilities, capacities, amenities and
            other details.
          </p>
        </div>
      ) : (
        <ComparisonTable
          hotels={selectedHotels}
          fields={COMPARISON_FIELDS}
          onRemove={removeHotel}
        />
      )}
    </section>
  );
}

export default HotelComparison;